<template>
  <div class="empreendimento">
    <div class="empreendimento__topo w-100 ui-image--cover" :style="'background-image: url('+ background +')'">
      <div class="container h-100">
        <div class="row h-100 align-items-end justify-content-center">
          <div class="col-12 text-center">
            <img class="title-image" :src="image">
          </div>
          <div class="col-12 text-center">
            <a v-if="folder" :href="folder" target="_blank">
              <button class="ui-button ui-button--yellow ui-button--yellow--transparent">
                Veja o folder
              </button>
            </a>
            <a v-if="video" target="_blank" data-toggle="modal" data-target="#ModalVideo">
              <button class="ui-button ui-button--yellow">
                Assista o vídeo
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- repetir imagens aqui também, pois aqui são as imagens da galeria -->
    <div class="images" v-viewer="{movable: false}" style="display: none;">
      <img :src="folder" :alt="folder">
    </div>
    <!-- modal video inicio -->
    <div class="modal fade" id="ModalVideo" tabindex="-1" role="dialog" aria-labelledby="ModalVideoLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <iframe width="100%" height="450" :src="'https://www.youtube.com/embed/' + video">
            </iframe>
          </div>
        </div>
      </div>
    </div>
    <!-- modal video fim -->
  </div>
</template>
<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue'
Vue.use(Viewer)
export default {
  props: ['background', 'folder', 'video', 'image'],
  methods: {
    openViewer () {
      const viewer = this.$el.querySelector('.images').$viewer
      viewer.show()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';
.empreendimento {
  &__topo {
    height: 850px;
    padding-bottom: 160px;
    button {
      margin: 0 10px;
    }
  }

  .title-image{
    margin-top: 100px;
  }
}
@media (max-width: 1400px){
  .empreendimento {
    &__topo {
      height: 100vh;
      padding-bottom: 50px;
    }
  }
}
@media (max-width: 1200px){
  .empreendimento {
    &__topo {
      height: 700px;
      padding-bottom: 100px;
    }
  }
}
@media (max-width: 991px){
  .empreendimento {
    &__topo {
      height: 650px;
      padding-bottom: 100px;
    }
  }
}
@media (max-width: 767px){
  .empreendimento {
    &__topo {
      height: 100vh;
      padding-bottom: 20px;
      button {
        margin: 10px 0;
      }
    }

    .title-image{
      max-width: 150px;
    }
  }
}
.modal-content {
  background: transparent;
}
.modal-body {
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/empreendimentos/InternaTopo.vue